export const levels = [
  {
    columns: 6,
    rows: 5,
    eggs: [[2,3]],
    rocks: [[1,3], [1,4], [2,2]],
  },
  {
    columns: 6,
    rows: 5,
    eggs: [[1,1], [3,3], [1,4], [4,5]],
    rocks: [[0,1], [1,3], [2,3], [4,4]],
  },
  {
    columns: 6,
    rows: 5,
    eggs: [[2,1], [0,3], [4, 0],[2,5]],
    rocks: [[1,0],[1,1],[1,2],[2,2],[3,2]],
  }
]